import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AppService} from '../../services/app.service';
import {ProductService} from '../../services/product.service';
import {Title} from '@angular/platform-browser';
import {ProductFilter} from '../../_models';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  selectedCity = '';
  selectedKeyword = '';
  responseReceived = false;
  products = [];
  category: any;
  merchant: any;
  city: any;
  response: any;
  pages = [];

  constructor(
    private http: HttpClient,
    public appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private titleService: Title
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.selectedCity = params.get('city');
      this.selectedKeyword = params.get('keyword');
    });

    this.titleService.setTitle('Things2do - Search Experiences');

    this.loadExperiences();
  }

  loadExperiences(page: number = 1): void {
    this.products = [];
    this.productService.searchExperiences(this.selectedCity, this.selectedKeyword).subscribe(response => {
        if (response) {
          this.products = response.data.data;
          this.response = response.data;
          this.responseReceived = true;
          this.pages = [];
          for (var i = 1; i <= this.response.last_page; i++) {
            this.pages.push(i);
          }

        }
      },
      error => {
        console.error('There was an error!', error);
      });
  }

  goToPage($page): void {
    if ($page <= 0) {
      $page = 1;
    }
    if ($page > this.response.last_page) {
      $page = this.response.last_page;
    }
    if ($page !== this.response.current_page) {
      this.loadExperiences($page);
    }
  }


  showProductDetail(product): void {
    this.router.navigate(['c/' + product.city.name.toLowerCase().toString() + '/' + product.slug]);
  }

}
